enum SortDirection {
    ASC = 'asc',
    DESC = 'desc',
}

export default SortDirection;
